
import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "allTurnover",
})
export default class allTurnover extends Vue {
  private tableData: Array<any> = [];
  private pageNo = 1;
  private pageSize = 10;
  private form = {};
  
  data() {
        return {
          options1: [{
            value1: '选项1',
            label1: '微信支付'
          }, {
            value1: '选项2',
            label1: '支付宝支付'
          }, {
            value1: '选项3',
            label1: '余额支付'
          }, {
            value1: '选项4',
            label1: '组合支付'
          }],
          value1: '',
		  options2: [{
		    value2: '选项1',
		    label2: '待发货'
		  }, {
		    value2: '选项2',
		    label2: '已发货'
		  }, {
		    value2: '选项3',
		    label2: '待品测'
		  }, {
		    value2: '选项4',
		    label2: '已完成'
		  }],
		  value2: '',
		  time:'',
        }
    }

  private get pagedTableData() {
    return this.tableData.filter(
      (v, i) =>
        i >= (this.pageNo - 1) * this.pageSize &&
        i <= this.pageNo * this.pageSize - 1
    );
  }

  private mounted() {
    let datas = [];
    let type = 2;
    let paramter = {
    	type
    };
    this.$http.get("user/list", {paramter}).then((res: any) => {
    	datas = res.data.data.data;
    	this.tableData = datas;
    	this.tableData = this.tableData.map(item=>{
    		item.enable = item.enable == 1?true:false;
    		return item;
    	});
    	console.log('普通用户',this.tableData);
    });
  }

  private handleSizeChange(val: number) {
    console.log(`每页 ${val} 条`);
    this.pageSize = val;
    this.pageNo = 1;
  }

  private handleCurrentChange(val: number) {
    console.log(`当前页: ${val}`);
    this.pageNo = val;
  }
  private onSubmit() {
    console.log(this.form);
  }
  private handleDetail(index,row){
  	  
  	  console.log(row);
	  this.$router.push('/Firm/orderDetail/?id='+row.id)
  }
}
